import MyAppointmentsProps, { Element } from "./my-appointments.types";

const dummieData: Element[] = [
  {
    id: "1",
    title: "Atención psicológica",
    details: [
      {
        id: "11",
        text: "Dayhana Loaiza Arias",
        help: "Psicóloga",
        icon: "🩺",
        featured: true
      },
      {
        id: "12",
        text: "Lunes 25 de septiembre 2023 | 3:00 p.m.",
        icon: "📅"
      }
    ]
  },
  {
    id: "2",
    title: "Hábitos saludables",
    details: [
      {
        id: "21",
        text: "Daniel Felipe Molina",
        help: "Psicólogo",
        icon: "🩺",
        featured: true
      },
      {
        id: "22",
        text: "Jueves 25 de mayo 2023 | 12:00 p.m.",
        icon: "📅"
      }
    ]
  },
  {
    id: "3",
    title: "Atención psicológica",
    details: [
      {
        id: "31",
        text: "María Valentina Uribe",
        help: "Psicóloga",
        icon: "🩺",
        featured: true
      },
      {
        id: "32",
        text: "Lunes 25 de septiembre 2023 | 3:00 p.m.",
        icon: "📅"
      },
      {
        id: "33",
        text: "Sesión grupal",
        help: "Debes asistir a la sesión grupal con tus amigos",
        icon: "👪"
      }
    ]
  }
];

const myAppointmentsAdapter = (data: any) => {
  const process: MyAppointmentsProps = {
    title: data.tituloGeneral,
    data: dummieData
  };
  return process;
};

export default myAppointmentsAdapter;
